import axios from "axios";
import { auth } from "../firebase";

// Trim stray whitespace and any trailing slash so a fat-fingered .env (e.g. a
// trailing space after the URL) can't turn every request into
// "http://host /api/..." — which the browser treats as an invalid URL and
// axios reports as a generic "Network Error".
const baseURL = (process.env.REACT_APP_API_URL || "http://localhost:4900")
  .trim()
  .replace(/\/+$/, "");

export const api = axios.create({ baseURL });

api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Money helpers — Stripe uses cents, we store dollars.
export const toCents = (dollars) => Math.round(Number(dollars || 0) * 100);
export const fromCents = (cents) => Number(cents || 0) / 100;
